<template>
  <BaseDataIterator ref="dataList" :service="fetchData" disable-search>
    <template #default="{ data }">
      <BaseDataTable :data="data">
        <template #header>
          <PerformanceWidgetListHeader />
        </template>

        <template #default="{ item }">
          <PerformanceWidgetListItem :insights="item.data" :key="item.time" />
        </template>
      </BaseDataTable>
    </template>
  </BaseDataIterator>
</template>

<script>
import { orderBy } from 'lodash-es';
import PerformanceWidgetListHeader from './PerformanceWidgetListHeader.vue';
import PerformanceWidgetListItem from './PerformanceWidgetListItem.vue';

export default {
  components: {
    PerformanceWidgetListHeader,
    PerformanceWidgetListItem,
  },
  props: {
    insights: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      perPage: 10,
      page: 1,
    };
  },
  computed: {
    filteredInsights() {
      return this.insights.filter((item) => item.data !== null);
    },
    insightsInDescendingOrder() {
      return orderBy(this.filteredInsights, ['time'], ['desc']);
    },
    total() {
      return this.insightsInDescendingOrder.length;
    },
    meta() {
      const lastPage = Math.ceil(this.total / this.perPage);
      const total = this.insightsInDescendingOrder.length;
      const from = (this.page - 1) * this.perPage + 1;
      const to = this.page * this.perPage > total ? total : this.page * this.perPage;
      return {
        current_page: this.page,
        from,
        last_page: lastPage,
        per_page: this.perPage,
        to,
        total,
      };
    },
  },
  watch: {
    insights: {
      deep: true,
      handler() {
        this.$refs.dataList.reset();
      },
    },
  },
  methods: {
    fetchData({ page = 1 } = {}) {
      return new Promise((resolve) => {
        this.page = page;
        resolve({
          data: this.insightsInDescendingOrder.slice(this.meta.from - 1, this.meta.to),
          meta: this.meta,
        });
      });
    },
  },
};
</script>
